import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch } from 'react-redux';
import { ACTIONS, ExpiringStorage } from '@oneaudi/stck-store';
import { MandatoryAreaSearchState } from '../types';
import { useServicesContext } from '../../../context';
import { useGoogleConsent } from '@oneaudi/two-click';
import { getScsUrlPartsFromConfiguration } from '../../../hooks';
import { ThemeProvider } from '@oneaudi/unified-web-common';
import { MasOverlay } from '../components';
const MANDATORY_AREA_SEARCH_TIMEOUT = 1000;
export const useMandatoryAreaSearch = (libraryLoaded) => {
    var _a;
    const { getConfiguration, getEnvironmentConfig } = useServicesContext();
    const configurationService = useServicesContext().getAdditionalService('vtp-configuration-service');
    const layerManager = useServicesContext().getAdditionalService('layer-manager');
    const scsUrlParts = getScsUrlPartsFromConfiguration(getConfiguration(), getEnvironmentConfig());
    const localStorageLocationSearchInputKey = `VTP_${scsUrlParts === null || scsUrlParts === void 0 ? void 0 : scsUrlParts.marketPath}_mandatoryLocationSearch--input`;
    const localStorage = new ExpiringStorage(localStorageLocationSearchInputKey, 30);
    const MASinputDataFromLocalStorage = localStorage.readEntry();
    const enableMandatoryAreaSearch = ((_a = configurationService === null || configurationService === void 0 ? void 0 : configurationService.getConfiguration()) === null || _a === void 0 ? void 0 : _a.enableMandatoryAreaSearch) || false;
    const consent = useGoogleConsent();
    const dispatch = useDispatch();
    const [mandatoryAreaSearchState, setMandatoryAreaSearchState] = useState(() => {
        var _a;
        return ((_a = configurationService === null || configurationService === void 0 ? void 0 : configurationService.getConfiguration()) === null || _a === void 0 ? void 0 : _a.enableMandatoryAreaSearch)
            ? MandatoryAreaSearchState.ENABLED
            : MandatoryAreaSearchState.DISABLED;
    });
    const [googleCookieConsent] = useState(() => { var _a; return (_a = configurationService === null || configurationService === void 0 ? void 0 : configurationService.getConfiguration()) === null || _a === void 0 ? void 0 : _a.enableGoogleCookieConsent; });
    const [mandatoryAreaSearchModalNode, setMandatoryAreaSearchModalNode] = useState();
    const [mandatoryAreaSearchModal, setMandatoryAreaSearchModal] = useState();
    const mandatoryAreaSearchModalRef = React.useCallback((node) => {
        setMandatoryAreaSearchModalNode(node);
    }, [setMandatoryAreaSearchModalNode]);
    const openMandatoryAreaSearchModal = () => {
        const modal = layerManager.openFocusLayer(() => React.createElement("div", { ref: mandatoryAreaSearchModalRef }), {}, {
            size: "A",
            userCloseable: false,
        });
        setMandatoryAreaSearchModal(modal);
    };
    const closeMandatoryAreaSearchModal = () => {
        mandatoryAreaSearchModal === null || mandatoryAreaSearchModal === void 0 ? void 0 : mandatoryAreaSearchModal.close();
        setMandatoryAreaSearchState(MandatoryAreaSearchState.LOCATION_SET);
        dispatch(ACTIONS.UI.setLoader({ state: false, feature: 'tiles' }));
    };
    const appendMasPortal = () => {
        return (React.createElement(React.Fragment, null, mandatoryAreaSearchModalNode &&
            libraryLoaded &&
            ReactDOM.createPortal(React.createElement(ThemeProvider, { theme: { name: 'light' } },
                React.createElement(MasOverlay, { closeMasOverlay: closeMandatoryAreaSearchModal, libraryLoaded: libraryLoaded, googleCookieConsent: googleCookieConsent })), mandatoryAreaSearchModalNode)));
    };
    useEffect(() => {
        if ((googleCookieConsent &&
            !consent &&
            mandatoryAreaSearchState === MandatoryAreaSearchState.ENABLED) ||
            (!googleCookieConsent &&
                mandatoryAreaSearchState === MandatoryAreaSearchState.ENABLED &&
                !MASinputDataFromLocalStorage)) {
            setTimeout(openMandatoryAreaSearchModal, MANDATORY_AREA_SEARCH_TIMEOUT);
            dispatch(ACTIONS.UI.setLoader({ state: true, feature: 'tiles' }));
        }
        if (mandatoryAreaSearchState === MandatoryAreaSearchState.ENABLED &&
            MASinputDataFromLocalStorage) {
            setMandatoryAreaSearchState(MandatoryAreaSearchState.LOCATION_SET);
        }
    }, []);
    return {
        googleCookieConsent,
        enableMandatoryAreaSearch,
        mandatoryAreaSearchState,
        setMandatoryAreaSearchState,
        openMandatoryAreaSearchModal,
        closeMandatoryAreaSearchModal,
        appendMasPortal,
    };
};
